// extracted by mini-css-extract-plugin
module.exports = {"qualification_lvl_item_wrapper":"QualificationForItemComponent_qualification_lvl_item_wrapper__3cFbU"};